<template>
    <v-container fluid fill-height px-0 class="main-container container-fixed d-block" v-if="profile">
        <div class="content-block">
            <HeaderMenu title="Профиль" class="mx-6 mb-6" :has-notification="profile.have_unread_messages"/>
            <div class="profile-block scroll-layout px-6" column>
    <!--            <div class="bold-text mb-4">-->
    <!--                Бонусный счет: <span class="main-text"> 500 </span>-->
    <!--            </div>-->
                <div class="main-text mb-4">
                    Вы проживаете в
                    <span class="bold-text">
                        {{ profile.room.hotel.name }}, {{ profile.room.floor }} этаж, номер {{ profile.room.name }}
                    </span>
                </div>
                <div class="main-text mx-0 mb-3 row-line">
                    <div class="d-inline-flex mr-3">
                        <v-img height="21px" width="18px" :src="require('@/assets/icons/location.png')"></v-img>
                    </div>
                    <div class="d-inline-flex profile-block__address">
                        {{ profile.room.hotel.address }}
                    </div>
                </div>
                <div class="map-container" v-if="coords.length > 0">
                    <yandex-map
                        :coords="coords"
                        :center="coords"
                        :zoom="14"
                        :settings="settings"
                        @click="onClick"
                        ymap-class="map-container__ymap"
                    >
                        <ymap-marker
                            :coords="coords"
                            marker-id="marker-map"
                            marker-type="placemark"
                        />
                    </yandex-map>
                </div>
                <a
                    :href="`https://yandex.ru/maps/?pt=${coords[1]},${coords[0]}&ll=${coords[1]},${coords[0]}&z=12`"
                    target="_blank"
                    v-if="coords.length"
                    class="main-text map-link"
                >
                    Проложить маршрут до отеля
                </a>
                <a :href="`tel:${profile.room.hotel.phone_number}`" class="mx-0 mb-3 row-line align-center">
                    <div class="d-inline-flex mr-3">
                        <PhoneIcon/>
                    </div>
                    <div class="main-text d-inline-flex profile-block__address">
                        {{ profile.room.hotel.phone_number }}
                    </div>
                </a>
                <a :href="profile.room.hotel.website_link" target="_blank" class="mx-0 mb-3 row-line align-center">
                    <div class="d-inline-flex mr-3">
                        <SiteIcon/>
                    </div>
                    <div class="d-inline-flex main-text profile-block__address">
                        {{ profile.room.hotel.website_link }}
                    </div>
                </a>
            </div>
        </div>
    </v-container>
</template>

<script>
import { yandexMap, ymapMarker } from 'vue-yandex-maps';
import HeaderMenu from "@/components/core/HeaderMenu";
import PhoneIcon from "@/assets/icons/PhoneIcon";
import SiteIcon from "@/assets/icons/SiteIcon";
import {eventBus} from "@/main";

export default {
    name: "ProfilePage",
    components: {
        yandexMap,
        ymapMarker,
        HeaderMenu,
        PhoneIcon,
        SiteIcon,
    },
    data() {
        return {
            profile: null,
            coords: [],
            settings: {
                lang: 'ru_RU',
                coordorder: 'latlong',
                enterprise: false,
            },
        };
    },
    created() {
        this.loadPage();
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("reconnect", this.loadPage);
    },
    methods: {
        loadPage() {
            if (this.$route.query.master_key) {
                this.$router.push({name: "master", query: this.$route.query});
            } else if (this.$store.state.accessToken) {
                this.getProfileData();
            } else {
                this.$router.push({ name: "empty" });
            }
        },
        getProfileData() {
            this.coords = [];
            this.$http.get('/hotels/guest/profile/')
                .then((response) => {
                    this.profile = response.data;
                    this.coords.push(response.data.room.hotel.geo_point_lat);
                    this.coords.push(response.data.room.hotel.geo_point_lon);
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.code == "access_key_expiration_date_has_expired") {
                        this.$router.push({ name: "final", params: { message: error.response.data.message }});
                    }
                });
        },
        onClick(e) {
            this.coords = e.get('coords');
        },
    },
}
</script>

<style lang="scss">
.profile-block {
    &::-webkit-scrollbar {
        display: none;
    }

    &__address {
        width: calc(100% - 40px);

        &:active {
            opacity: 0.6;
            text-decoration: underline;
        }
    }

    a {
        align-items: center;
        text-decoration: none;
        width: 100%;
    }
}

.map-container {
    position: relative;
    width: 100%;
    min-height: 240px;
    margin-bottom: 10px;

    &__ymap {
        width: 100%;
        min-height: 240px;
    }

    .ymap-container {
        height: 100%;
        border-radius: 16px;

        div > ymaps > ymaps {
            min-height: 240px;
            border-radius: 16px;

            > ymaps {
                border-radius: 16px;
            }
        }
    }
}

a.map-link {
    height: 42px;
    padding: 10px 0;
    color: #130F26;
    text-decoration: none;
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    background: rgba(247, 247, 249, 0.38);
    box-shadow: 0px 4px 15px rgba(37, 37, 37, 0.1);
    border-radius: 64px;
    margin-bottom: 16px;

    &:active {
        background: rgba(0, 0, 0, 0.24);
    }
}
</style>